import {
    includeRule,
    excludeRule
  }
  from './rules_functions.js';
  
export function rules_rmet(newState, state) {
  var newrule = includeRule(newState, state, 'rmet')

    newrule = excludeRule(newState, state, [
        ['rmet', ['0']]], newrule)

    newrule = excludeRule(newState, state, [
        ['hmet', ['10W', '10Y', '10R']],
        ['rmet', ['14W', '14Y', '14R']]], newrule)

    newrule = excludeRule(newState, state, [
        ['hmet', ['14W', '14Y', '14R']],
        ['rmet', ['10W', '10Y', '10R']]], newrule)

    newrule = excludeRule(newState, state, [
        ['type', ['B']],
        ['rmet', ['14W', '14Y', '14R']]], newrule)

    return newrule
}



// WEBPACK FOOTER //
// ./src/reducers/rules_rmet.js